<template>
  <div class='pdf'>
    <pdf-components @url="url"/>
    <!-- <div>
      <el-card class="qianming-container" body-style="padding:0px">
        <vue-esign ref="esign" :isCrop="isCrop" :width="350" :height="200" :lineWidth="lineWidth" :lineColor="lineColor" bgColor="#fff" :isClearBgColor="false" v-if="flag"></vue-esign>
        <div class="card" v-else></div>
        <div class="contro-container">
          <el-button type="primary" @click="flag =true">开始签名</el-button>
          <el-button type="danger" @click="handleReset">清空</el-button>
          <el-button type="primary" @click="handleGenerate">确认</el-button>
        </div>
      </el-card>
    </div> -->
    <div class="handwritten-name-wrap">
      <div class="btn">
        <el-button type="primary" @click.native="handleClick"  v-show="!showPdf&&showbtn">
          点击签名
        </el-button>
        <el-button type="primary" @click.native="downloadPdf" v-show="showPdf">
          pdf下载
        </el-button>
        <!-- <el-button type="success" @click="handleGenerate" size="small">
          提交
        </el-button> -->
      </div>
      <!-- <div class="img-wrap">
        <img :src="imgSrc" alt="" v-if="imgSrc">
      </div> -->
      <el-dialog :visible.sync="panelVisible" title="手写签名" fullscreen :destroy-on-close="true" class="signNameModel" top="0">
        <template slot="title">
          <div>
            <p>手写签名</p>
            <div class="gtnGroup">
              <!-- <el-button type="primary" size="mini" @click="undo">撤销</el-button> -->
              <el-button type="primary" size="mini" @click="save">提交</el-button>
            </div>
          </div>
        </template>
        <template>
          <el-dialog width="80%" class="submitModel" title="确认" :visible.sync="submitVisible" append-to-body>
            <img :src="imgSrc" alt="">
            <img :src="imgSrc1" alt="">
            <p>签名提交后,不允许修改,您确定提交确认吗?</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="submitVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleGenerate">确认</el-button>
            </div>
          </el-dialog>
          <!-- <div class="otherSet">
            <div class="penTxt">笔刷大小：</div>
            <div class="circleWrap" :class="{ active: isActive1 }" @click="selSize(1)"><b class="b1"></b></div>
            <div class="circleWrap" :class="{ active: isActive2 }" @click="selSize(2)"><b class="b2"></b></div>
            <div class="circleWrap" :class="{ active: isActive3 }" @click="selSize(3)"><b class="b3"></b></div>
          </div> -->
          <div class="signWrap" @touchmove.prevent>
            <div class="signBox">
              <p> 此处手写输入（与现场一致或与原件一致）<el-button type="danger" size="mini" @click="clear">清空信息</el-button></p>
              <el-row class="mainBox">
                <el-col :span="8">
                  <VueSignaturePad width="100%" height="100%" ref="sign1" :options="options" />
                </el-col>
                <el-col :span="8">
                  <VueSignaturePad width="100%" height="100%" ref="sign2" :options="options" />
                </el-col>
                <el-col :span="8">
                  <VueSignaturePad width="100%" height="100%" ref="sign3" :options="options" />
                </el-col>
                <el-col :span="8">
                  <VueSignaturePad width="100%" height="100%" ref="sign4" :options="options" />
                </el-col>
                <el-col :span="8">
                  <VueSignaturePad width="100%" height="100%" ref="sign5" :options="options" />
                </el-col>
                <el-col :span="8">

                </el-col>
              </el-row>
            </div>
            <!-- <el-divider><i class="el-icon-mobile-phone"></i></el-divider> -->
            <!-- <el-divider></el-divider> -->
            <div class="signBox lastBox">
              <p> 确 认 人<el-button type="danger" size="mini" @click="clearSign">清空签名</el-button></p>
              <VueSignaturePad width="100%" height="95%" ref="signature" :options="options" />
            </div>

            <!-- <footer>
              

            </footer> -->
            <!-- <img :src="imgSrc" alt=""> -->
          </div>
        </template>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import PdfComponents from './components/pdf.vue'
import { sumbitfile,getEvMsg} from "@/api";
// import { saveAs } from 'file-saver';
// import { getToken } from '@/utils/auth'
export default {
  components: {
    PdfComponents
  },
  data () {
    return {
      isCrop: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      id: null,
      flag: false,
      panelVisible: false,
      submitVisible: false,
      panelTitle: "",
      options: {
        penColor: "#000",
        minWidth: 1,    //控制画笔最小宽度
        maxWidth: 1,    //控制画笔最大宽度
      },
      isActive1: true,
      isActive2: false,
      isActive3: false,
      imgSrc: "",
      imgSrc1: "",
      list: [1, 2, 3, 4, 5],
      showPdf:true,
      showbtn: true,
      pdfId:null,
      pdfUrl:null,
      // loading: false
    };
  },
  created () {
    console.log(this.$route.params);
    console.log(this.$route.query);
    // this.id = Number(this.$route.params.id.replace('预警信息,请上平台查看', ''))
    this.id = Number(this.$route.params.id)
    if (this.$route.query.status) {
      this.showPdf=true
    }else{
      this.showPdf=false
    }
    this.getbaseinfo()
  },
  mounted () {

  },
  methods: {
 async getbaseinfo(){
  const res = await getEvMsg(this.id)
  this.pdfId=res.data.docNo
  // console.log(res);
  if (res.data.commentPic) {
    this.showbtn=false
  }else{
    this.showbtn=true
  }
  },
    //清空画板..
    handleReset () {
      this.$refs.esign.reset();
      this.resultImg = "";
    },
    //生成签名图片..
    async handleGenerate () {
      if (this.imgSrc) {
        let randnum = Math.random() * 10000000000000;
        randnum = Math.floor(randnum);
        let fileName = "querenyijian/" + randnum + ".png";
        let fileName1 = "querenren/" + randnum + ".png";
        let file = await this.dataURLtoFile(this.imgSrc, fileName);
        let file1 = await this.dataURLtoFile(this.imgSrc1, fileName1);
        // console.log(file);
        let formdata = new FormData()
        formdata.append('commentPic', file, fileName)
        formdata.append('confirmorPic', file1, fileName1)
        formdata.append('signType', 2)

        // console.log('params :>> ', params);
        sumbitfile(this.id, formdata).then(res => {
          if (res && res.code === 200) {
            // console.log(111);
            this.$message.success("签名上传成功");
            this.submitVisible = false
            this.panelVisible = false;
            this.$router.go(0)
          }
        })
      } else {
        this.$message.error('请签名之后提交！')
      }
    },
    //将base64转换为文件..
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    //手写签名按钮的点击
    handleClick () {
      this.panelVisible = true;
      // this.isActive1 = true;
      // this.isActive2 = false;
      // this.isActive3 = false;
      this.options = {
        penColor: "#000",
        minWidth: 2,
        maxWidth: 2,
      }
    },
    //撤销
    undo () {
      this.$refs.signaturePad.undoSignature();
    },
    //清除
    clear () {
      // this.$refs.signaturePad.clearSignature();
      this.list.map(el => {
        this.$refs[`sign${el}`].clearSignature()
      })
    },
    // 清楚签名
    clearSign () {
      this.$refs.signature.clearSignature();
    },

    async save () {
      const a = this.list.every(el => this.$refs[`sign${el}`].saveSignature().data)
      if (!a) {
        this.$message.error('请完整填写')
        return
      }
      if (!this.$refs.signature.saveSignature().data) {
        this.$message.error('请签名')
        return
      }
      // this.mergeImgs(this.list, 80, 240).then((base64) => {
      //   // console.log('base64', base64)

      // })
      const base64 = await this.mergeImgs(this.list, 80, 240)
      this.imgSrc = base64
      this.ceratePic()
      // } else {
      //   this.$message.error('请签名')
      // }
      // }
    },
    // 生成签名照片
    ceratePic () {
      let canvas = document.createElement('canvas');
      canvas.width = 480;
      canvas.height = 240;
      let context = canvas.getContext('2d');
      context.rect(0, 0, canvas.width, canvas.height);
      let img = new Image();
      img.src = this.$refs.signature.saveSignature().data;
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        context.drawImage(img, 0, 0, 480, 240);
        let base64 = canvas.toDataURL('image/png');
        this.imgSrc1 = base64
        this.submitVisible = true
      }
    },
    mergeImgs (list, cwith, cheight) {
      return new Promise((resolve) => {
        const baseList = [];
        // 创建 canvas 节点并初始化
        const canvas = document.createElement('canvas');
        canvas.width = cwith * list.length;
        canvas.height = cheight;
        const context = canvas.getContext('2d');
        list.map((item, index) => {
          const img = new Image();
          img.src = this.$refs[`sign${item}`].saveSignature().data;
          // 跨域
          img.crossOrigin = 'Anonymous';
          img.onload = () => {
            context.drawImage(img, cwith * index, 0, cwith, cheight);
            const base64 = canvas.toDataURL('image/png');
            baseList.push(base64);
            if (baseList[list.length - 1]) {
              // 返回新的图片
              resolve(baseList[list.length - 1]);
            }
          };
        });
      });
    },
    //调节画笔粗细大小
    selSize (val) {
      this.options = {
        penColor: "#000",
        minWidth: val,
        maxWidth: val,
      };
      if (val == 1) {
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
      } else if (val == 2) {
        this.isActive1 = false;
        this.isActive2 = true;
        this.isActive3 = false;
      } else if (val == 3) {
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = true;
      }
    },
  // async downloadPdf(){
  // const res =await getpdf(this.id)
  // console.log(res);
  // const pdfBlob = new Blob([res], { type: "application/pdf" });
  // const url = URL.createObjectURL(pdfBlob);
  // const link = document.createElement("a");
  // link.href = url;
  // link.download = `拱墅卫监-${this.id}.pdf`;
  // link.click();
  // URL.revokeObjectURL(url);

  
  // // console.log(res)
  // }
url(val){
  this.pdfUrl=val
},
async downloadPdf(){
  // const res = await getpdf(this.id)
  // console.log(res);
  // // const pdfBlob = new Blob([res],{ type: "application/pdf" });
  // saveAs(res, `拱墅卫监-${this.pdfId}.pdf`);
  window.open(`https://record.terabits.cn${this.pdfUrl}`)
}
  }
};
</script>

<style scoped lang="scss">
.pdf {
  display: flex;
  flex-direction: column;
  align-items: center;
}

// .qianming-container {
//   width: 100vw;
//   height: 40vh;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   box-sizing: border-box;
//   padding: 10px;
//   background: #efefef;
//   .contro-container {
//     width: 350px;
//     height: 50px;
//     display: flex;
//     // flex-direction: row;
//     align-items: center;
//     justify-content: space-around;
//     background-color: rgb(230, 230, 230);
//   }
//   // margin: 20px auto;
//   // position: relative;
// }
// .text {
//   font-size: 14px;
// }
// .item {
//   margin-bottom: 18px;
// }
// .card {
//   height: 200px;
//   width: 100%;
//   background: #fff;
// }
.handwritten-name-wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  border-top: 2px dotted rgb(231, 230, 230);
  .btn {
    .el-button {
      // margin-bottom: 10px;
      padding: 12px 30px;
      font-size: 18px;
    }
  }
  .img-wrap {
    width: 100%;
    // height: 164px;
    height: 15vh;
    margin-left: 5px;
    border: 1px solid #ccc;
    img {
      width: 80%;
      height: 100%;
    }
  }
  ::v-deep .el-dialog {
    margin: 0;
  }
  ::v-deep .signNameModel {
    // height: 100vh;
    // .el-dialog {
    //   // height: 100%;
    //   // margin: 0 !important;
    // }
    .el-dialog__header {
      padding: 10px;
      border-bottom: 1px solid rgb(205, 205, 205);
      .el-dialog__headerbtn {
        top: 15px;
      }
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 50px;
        p {
          font-size: 16px;
          font-weight: bold;
          // margin-right: 100px;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      height: 90%;
      .otherSet {
        // width: 50%;
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // .penTxt {
        //   // width: 70px;
        // }
        .selSize {
          width: 70px;
        }
        .el-select__caret {
          position: absolute;
          right: -3px;
        }
        .b1,
        .b2,
        .b3 {
          display: inline-block;
          background: #000;
          border-radius: 50%;
        }
        .circleWrap {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          cursor: pointer;
          margin-right: 20px;
        }
        .active {
          border: 1px dashed #0074d9;
        }
        .b1 {
          width: 4px;
          height: 4px;
        }
        .b2 {
          width: 6px;
          height: 6px;
        }
        .b3 {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
  .signWrap {
    // height: 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // border-top: 1px dotted rgb(231, 230, 230);
    .signBox {
      height: 50vh;
      margin-top: 5px;
      > p {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        .el-button {
          margin-left: 10px;
        }
      }
      // box-shadow: 1px 1px 5px 1px rgb(179, 179, 179);
      // border-top: 1px dotted rgb(179, 179, 179);
      // border-bottom: 1px dotted rgb(179, 179, 179);
      .mainBox {
        margin-top: 10px;
        height: 90%;
        .el-col {
          height: 50%;
          box-sizing: border-box;
          border: 1px dotted #999;
          border-left: none;
        }
        .el-col:nth-of-type(3n) {
          border-right: none;
        }
        .el-col:nth-of-type(1),
        .el-col:nth-of-type(2),
        .el-col:nth-of-type(3) {
          border-bottom: none;
        }
        // display: flex;
        // flex-wrap: w;
      }
    }
    .lastBox {
      height: 32vh;
      > p {
        border-bottom: 1px dotted rgb(179, 179, 179);
      }
    }
    .signName {
      flex: 1;
      border-top: 1px solid #ccc;
    }
    footer {
      // height: 40px;
      padding: 10px;
      border-top: 1px solid #ccc;
      .gtnGroup {
        // width: 50%;
        display: flex;
        justify-content: flex-end;
        // margin-left: 20px;
      }
    }
  }
}
// .signNameModel {
//   .vxe-modal--content {
//     padding: 0 !important;
//   }
// }
</style>
